import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

class SubscribeToSubjectEvents {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
	) {
		Object.freeze(this);
	}

	get url(): string {
		return `${buildSubjectApiPath(this.facilityId, this.subject)}/events`;
	}

	/** Asks the server to replay the whole dossier first, for a connection that may have missed changes. */
	get reconnectionUrl(): string {
		return `${this.url}?catchUp=true`;
	}
}

export default SubscribeToSubjectEvents;
